/**
 * The date parser the page's Firestore readers share. A leaf: it imports nothing, so both the
 * view model and `status` can read it without importing each other at runtime.
 */

/** Firestore `Timestamp`, `Date`, ISO string or epoch number -> `Date`. Duck-typed on `toDate`. */
export function parseDateValue(value: unknown): Date | undefined {
  if (value === null || value === undefined || value === "") return undefined;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? undefined : value;
  if (typeof value === "object" && typeof (value as { toDate?: unknown }).toDate === "function") {
    const converted = (value as { toDate: () => Date }).toDate();
    return converted instanceof Date && !Number.isNaN(converted.getTime()) ? converted : undefined;
  }
  if (typeof value === "string" || typeof value === "number") {
    const converted = new Date(value);
    return Number.isNaN(converted.getTime()) ? undefined : converted;
  }
  return undefined;
}
